import React, { useEffect, useRef } from 'react';
import { Col } from 'antd';
import { FaCloudDownloadAlt, FaEllipsisV } from 'react-icons/fa';
import axios from 'axios';
import { SERVER_URL } from '../../../databucket';
import { Dropdown } from 'react-bootstrap';
import Link from 'antd/es/typography/Link';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setLoader } from '../../../Slices/loaderSlice';
import { useErrorLogger } from "../../../utils";
import { createAttachmentsAsync, deleteAttachmentAsync, fetchAttachmentsByIdAsync, updateAttachmentAsync } from '../../../Slices/orderSlice';
import { AntdButton } from '../../../blueplanitUtils/InputField';
import { CustomGridTable } from '../../../blueplanitUtils/CustomGridTable';
import dayjs from 'dayjs';
import { S3ACCESSURL } from '../../../databucket';
export default function AttachemntsHistory(props) {

    let employeeDetails = props.employeeDetails;
    let setEmployeeDetails = props.setEmployeeDetails;
    const { RequestInfo } = props;
    const fileInputRef = useRef(null);
    const fileInputRefSingle = useRef(null);
    const { logError } = useErrorLogger();
    const dispatch = useDispatch();

    const attachmentsHistory = useSelector((state) => state.orders.attachmentsHistory);
    const attachmentworkhistory = useSelector((state) => state.orders.attachmentworkhistory);

    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);

    useEffect(() => {
        if (RequestInfo?.id && loginUser?.id) {
            dispatch(fetchAttachmentsByIdAsync(RequestInfo?.id))
        }
    }, [dispatch, RequestInfo?.id, loginUser.id])

    const handleSingleAttachment = async (event, index) => {
        try {
            dispatch(setLoader(true));
            const selectedFile = event.target.files[0];
            const formData = new FormData();
            formData.append('files', selectedFile);
            const uploadRes = await axios.post(`${SERVER_URL}/upload`, formData);
            const savedFile = uploadRes.data.files[0];

            const valuesObject = {
                userId: loginUser?.id,
                emailId: RequestInfo?.id,
                data: savedFile.url,
                filename: savedFile.originalName,
                mimetype: savedFile.mimeType,
                addDate: Date.now().toString(),
                updateDate: Date.now().toString(),
                status: true,
            };

            const resultAction = await dispatch(createAttachmentsAsync(valuesObject));

            if (createAttachmentsAsync.fulfilled.match(resultAction)) {
                dispatch(fetchAttachmentsByIdAsync(RequestInfo?.id))
            } else {
                console.error('Attachment creation failed:', resultAction.payload);
            }
            const key = 'Attachment'
            setEmployeeDetails({ ...employeeDetails, [key]: selectedFile });
        } catch (error) {
            logError('AttachmentsHistory', 'upload single Attachments', error.message);
        } finally {
            dispatch(setLoader(false));
        }
    };

    const handleMultipleAttachment = async (event, index) => {
        try {
            dispatch(setLoader(true));

            const multipleFiles = Array.from(event.target.files);
            const formData = new FormData();

            multipleFiles.forEach((file) => {
                formData.append('files', file);
            });

            const uploadRes = await axios.post(`${SERVER_URL}/upload`, formData);
            const uploadedFiles = uploadRes?.data?.files;
            if (!Array.isArray(uploadedFiles)) {
                throw new Error('Uploaded files response is not an array');
            }
            for (const file of uploadedFiles) {
                const valuesObject = {
                    userId: loginUser?.id,
                    emailId: RequestInfo?.id,
                    data: file.url,
                    filename: file.originalName,
                    mimetype: file.mimeType,
                    addDate: Date.now().toString(),
                    updateDate: Date.now().toString(),
                    status: true,
                };

                const resultAction = await dispatch(createAttachmentsAsync(valuesObject));

                if (!createAttachmentsAsync.fulfilled.match(resultAction)) {
                    console.error('Attachment creation failed:', resultAction.payload);
                }
            }
            dispatch(fetchAttachmentsByIdAsync(RequestInfo?.id));
        } catch (error) {
            console.error("Error uploading multiple attachments:", error);
            logError("AttachmentsHistory", "upload multiple Attachments", error.message);
        } finally {
            dispatch(setLoader(false));
        }
    };

    const handleupadteAttachment = (event) => {
        return event.target.files[0];
    }
    const updateHandler = async (attachemntId) => {
        try {
            const selectedFilePromise = new Promise((resolve, reject) => {
                const inputElement = document.getElementById('updateAttachmentInput');
                inputElement.addEventListener('change', (event) => {
                    const selectedFile = event.target.files[0];
                    resolve(selectedFile);
                });
                inputElement.click();
            });

            const selectedFile = await selectedFilePromise;


            const formData = new FormData();
            formData.append('files', selectedFile);
            dispatch(setLoader(true))
            const uploadRes = await axios.post(SERVER_URL + '/upload', formData)
            const savedFile = uploadRes.data.files[0];
            const valuesObject = {
                userId: loginUser?.id,
                id: attachemntId,
                data: savedFile.url,
                filename: savedFile.originalName,
                mimetype: savedFile.mimeType,
                updateDate: Date.now().toString(),
            }
            const resultAction = await dispatch(updateAttachmentAsync(valuesObject));

            if (updateAttachmentAsync.fulfilled.match(resultAction)) {
                dispatch(fetchAttachmentsByIdAsync(RequestInfo?.id))
                dispatch(setLoader(false))
            } else {
                console.error('Attachment creation failed:', resultAction.payload);
            }
        }
        catch (error) {
            logError("AttachmentsHistory", "update the attachments file", error.message)
        }

    }

    const deleteHandler = async (attachemntId) => {
        try {
            dispatch(setLoader(true))
            const valuesObject = {
                userId: loginUser?.id,
                id: attachemntId,
                updateDate: Date.now().toString(),
            }
            const result = await dispatch(deleteAttachmentAsync(valuesObject));

            if (deleteAttachmentAsync.fulfilled.match(result)) {
                // Refresh list
                await dispatch(fetchAttachmentsByIdAsync(RequestInfo?.id));
            } else {
                console.error('Failed to delete:', result.payload);
            }
        }
        catch (error) {
            logError("AttachmentsHistory", "delete the attachments file", error.message)
        }
        finally {
            dispatch(setLoader(false))
        }
    }


    const handleDownload = (fileUrl, fileName) => {

        try {
            fetch(S3ACCESSURL+fileUrl)
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error('Error downloading file:', error)
                });
        }
        catch (error) {
            logError("AttachmentsHistory", "download the attachments file", error.message)
        }
    };

    const getDateTime = (timeValue) => {
        const startDate = new Date(timeValue).toLocaleDateString();
        const startTimeString = new Date(timeValue).toLocaleTimeString(undefined, { hour12: true });

        const dateTimeString = `${startDate} ${startTimeString}`;

        return dateTimeString;
    }

    const getStatus = (status, addDate, updateDate) => {
        let resultData = ""
        if (status) {
            if (addDate === updateDate) {
                resultData = "Created"
            } else {
                resultData = "Deleted"
            }
        } else {
            resultData = "Updated"
        }
        return resultData;
    }

    const assignToUsers = useSelector((state) => state.loginUserInfo.allUsers)

    const getUserName = (userid) => {



        let userName = 'outlook-bot';
        assignToUsers?.forEach((userdetails) => {
            if (userdetails?.id === userid) {
                userName = `${userdetails?.firstname} ${userdetails?.lastname}`;
            }
        });
        return userName;
    };

    const attachmentsColumns = [
        {
            title: "Attachments",
            dataIndex: "filename",
            key: "filename",
            align: "center",
            render: (text, record) => (
                <a href={S3ACCESSURL + record.data} target="_blank" rel="noreferrer">{text}</a>
            ),
        },
        {
            title: "Add Date",
            dataIndex: "addDate",
            key: "addDate",
            align: "center",
            render: (text) => dayjs(text).format("DD/MM/YYYY hh:mm A"),
        },
        {
            title: "User Name",
            dataIndex: "userId",
            key: "userId",
            align: "center",
            render: (userId) => getUserName(userId),
        },
        {
            title: "Actions",
            key: "actions",
            align: "center",
            render: (_, record) => (
                <AntdButton
                    label="Download"
                    icon={<FaCloudDownloadAlt />}
                    variant="primary"
                    onClick={() => handleDownload(record.data, record.filename)}
                />
            ),
        },
        {
            title: "Options",
            key: "options",
            align: "center",
            render: (_, record) => (
                <Dropdown drop="end">
                    <Dropdown.Toggle as="span" style={{ cursor: 'pointer' }}>
                        <FaEllipsisV size={16} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <>
                            <Dropdown.Item onClick={() => updateHandler(record.id)}>
                                Replace
                            </Dropdown.Item>
                            <input type="file" id="updateAttachmentInput" onChange={handleupadteAttachment} style={{ display: 'none' }} />
                        </>
                        <Dropdown.Item onClick={() => deleteHandler(record.id)}>
                            Delete
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            ),
        },
    ];

    const columns = [
        {
            title: "S.No",
            key: "sno",
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: "Attachments",
            dataIndex: "filename",
            key: "filename",
            align: "center",
            render: (text, record) => (
                <a href={record.data} target="_blank" rel="noreferrer">{text}</a>
            ),
        },
        {
            title: "Add Date",
            dataIndex: "addDate",
            key: "addDate",
            align: "center",
            render: (text) => dayjs(parseInt(text)).format("DD/MM/YYYY hh:mm a"),
        },
        {
            title: "Update Date",
            dataIndex: "updateDate",
            key: "updateDate",
            align: "center",
            render: (text) => text ? dayjs(parseInt(text)).format("DD/MM/YYYY hh:mm a") : "-",
        },
        {
            title: "User Name",
            dataIndex: "userId",
            key: "userId",
            align: "center",
            render: (userId) => getUserName(userId),
        },
        {
            title: "Actions",
            key: "actions",
            align: "center",
            render: (_, record) => getStatus(record.status, record.addDate, record.updateDate),
        },
    ]

    const dataSource = attachmentsHistory
        .filter(row => row.status !== false)
        .map(row => ({
            ...row,
            key: row.id,
        }));

    const attachmenthistory = attachmentworkhistory
        .map(row => ({
            ...row,
            key: row.id,
        }));

    return (
        <>
            <div className="col-md-12 d-flex overflow-hidden" >
                <div className="card profile-box flex-fill">
                    <div className="card-body">
                        <h3 className="card-title" style={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between', fontWeight: 'bold' }}>
                            Attachments

                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <Col style={{ color: "#4A90E2", cursor: "pointer" }}>
                                    <input
                                        type="file"
                                        ref={fileInputRefSingle}
                                        onChange={handleSingleAttachment}
                                        style={{ display: 'none' }}
                                    />
                                    <Link onClick={() => fileInputRefSingle.current && fileInputRefSingle.current.click()}>

                                        <i
                                            className="fa-solid fa-file"
                                            style={{
                                                fontSize: "20px",
                                            }}
                                            aria-label="Add Single Attachment"
                                        />
                                    </Link>
                                </Col>

                                <Col style={{ color: "#4A90E2", cursor: "pointer" }}>
                                    <input
                                        type="file"
                                        multiple
                                        ref={fileInputRef}
                                        onChange={handleMultipleAttachment}
                                        style={{ display: 'none' }}
                                    />
                                    <Link onClick={() => fileInputRef.current && fileInputRef.current.click()}>
                                        <i
                                            className="fa-regular fa-folder-open"
                                            style={{
                                                fontSize: "20px",

                                            }}
                                            aria-label="Add Multiple Attachments"
                                        />

                                    </Link>
                                </Col>


                            </div>
                        </h3>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='table-responsive'>
                                    <CustomGridTable
                                        columns={attachmentsColumns}
                                        Id="attachments-history-table"
                                        dataSource={dataSource}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12 d-flex overflow-hidden" >
                <div className="card profile-box flex-fill">
                    <div className="card-body">
                        <h3 className="card-title" style={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between', fontWeight: 'bold' }}>
                            Attachments History
                        </h3>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='table-responsive'>
                                    <CustomGridTable
                                        columns={columns}
                                        Id="attachments-work-history-table"
                                        dataSource={attachmenthistory}
                                        pagination={false}

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
